module.exports = __webpack_public_path__ + "img/nxticon.cb3fad9a.svg";